import {Pipe, PipeTransform, ChangeDetectorRef} from "@angular/core";
import {ConfigurationService} from "./configuration.service";
import {Subscription} from "rxjs";

@Pipe({
    name: 'stringConfig',
    pure: false
})
export class StringConfigPipe implements PipeTransform {
    configSpec: string = null;
    value: string = null;
    subscription: Subscription;

    constructor(private configurationService: ConfigurationService, private ref: ChangeDetectorRef) {
        this.subscription = configurationService.configurationChanges.subscribe((configSpec: string) => {
            if (configSpec === this.configSpec) {
                this.configSpec = null;
                this.value = null;
                this.ref.markForCheck();
            }
        })
    }

    transform(configSpec: string): string {
        if (configSpec !== this.configSpec) {
            this.configSpec = configSpec;
            this.value = null;
            this.configurationService.getString(configSpec).then((value: string) => {
                this.value = value;
                this.ref.markForCheck();
            });
        }
        return this.value;
    }

    ngOnDestroy() {
        if(this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
